import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { HttpClient } from '@angular/common/http';
import { UserGroupWithMembersDTO } from '@sb-tools/typescript/models/dto/user-group-with-members.dto';

@Injectable({
    providedIn: 'root',
})
export class UserGroupService {
    constructor(private httpClient: HttpClient) {}

    get(groupId: number): Observable<UserGroupWithMembersDTO> {
        return this.httpClient.get<UserGroupWithMembersDTO>(environment.apiInboxUrl + 'UserGroups/' + groupId);
    }
}
